import { AuthBaseClient } from '../base-client';
import type {
  ClassificationLabelResponse,
  CreateClassificationLabelRequest,
  UpdateClassificationLabelRequest,
} from './types';

/**
 * Client for classification label management API endpoints.
 */
export class ClassificationLabelClient extends AuthBaseClient {
  /**
   * List all classification labels for the organization.
   */
  async list(): Promise<ClassificationLabelResponse[]> {
    return this.get<ClassificationLabelResponse[]>('/api/classification-labels');
  }

  /**
   * Create a new custom classification label.
   */
  async create(data: CreateClassificationLabelRequest): Promise<ClassificationLabelResponse> {
    return this.post<ClassificationLabelResponse>('/api/classification-labels', data);
  }

  /**
   * Update a classification label.
   */
  async update(
    id: string,
    data: UpdateClassificationLabelRequest
  ): Promise<ClassificationLabelResponse> {
    return this.patch<ClassificationLabelResponse>(`/api/classification-labels/${id}`, data);
  }

  /**
   * Delete a custom classification label.
   */
  async deleteLabel(id: string): Promise<void> {
    return this.delete<void>(`/api/classification-labels/${id}`);
  }
}
